/* =========================================================
   GIFT OF WATER — Donation Widget slot-mover (updated plugin)
   ---------------------------------------------------------
   Naya "Donate Directly" plugin (class="donation-widget",
   attribute data-donation-widget) apna poora UI khud handle
   karta hai (toggle, presets, custom amount, footer, icons —
   sab kuch). Is script ka kaam SIRF itna hai:

     Plugin ke app blocks jo page ke top par insert hote hain
     (hero + 3 cards ke liye 4 baar add kiye gaye) unko unki
     design slots mein reposition karna, DOM order preserve
     karte hue:

       1st .shopify-app-block (jisme .donation-widget mile) -> hero slot
       2nd  -> card slot 1
       3rd  -> card slot 2
       4th  -> card slot 3

   Poora .shopify-app-block (jisme donation-widget div,
   uska <link> aur <script> tag bhi shamil hai) move hota
   hai — sirf andar wala .donation-widget div nahi — taake
   plugin ka apna CSS/JS setup intact rahe.

   Koi toggle / amount / footer / custom-amount logic yahan
   NAHI hai — woh sab ab plugin khud sambhal raha hai.
   ========================================================= */
(function () {
  'use strict';

  var CONFIG = {
    heroSlot:  '.gow-hero .gow-hero__widget .gow-appslot, .mmb .mmb__widget .gow-appslot', // image hero or Makkah video banner
    cardSlots: '.gow-section--page .gow-card .gow-appslot',

    pollMs: 500,          // re-scan cadence jab tak blocks render na ho jayein
    pollMaxAttempts: 20,  // hard stop for the polling interval

    debug: true           // console diagnostics ke liye, false kar dein production mein
  };

  var pollTimer = null;
  var pollAttempts = 0;

  /* ---------- identify: yeh app block humara donation plugin hai? ---------- */
  function isDonationWidget(el) {
    return !!el.querySelector('.donation-widget, [data-donation-widget]');
  }

  /* ---------- relocate: poora .shopify-app-block move karo slot mein ---------- */
  function moveWidgets() {
    var blocks = Array.prototype.slice
      .call(document.querySelectorAll('.shopify-app-block'))
      .filter(isDonationWidget);

    if (!blocks.length) return false;

    var cardSlots = document.querySelectorAll(CONFIG.cardSlots);
    var slots = [
      document.querySelector(CONFIG.heroSlot),
      cardSlots[0],
      cardSlots[1],
      cardSlots[2]
    ];

    var target = slots.filter(Boolean).length; // kitne slots actually page par maujood hain
    var moved = 0;

    for (var i = 0; i < slots.length; i++) {
      var slot = slots[i];
      var block = blocks[i];
      if (!slot || !block) continue;

      if (slot.contains(block)) {
        moved++;
        continue;
      }

      slot.appendChild(block); // poora app block (link + script + donation-widget) move
      moved++;

      if (CONFIG.debug) {
        console.log('[GOW] block #' + (i + 1) + ' moved to slot:', slot);
      }
    }

    return moved === target;
  }

  /* ---------- diagnostics ---------- */
  function diagnose() {
    if (!CONFIG.debug) return;
    var blocks = Array.prototype.slice
      .call(document.querySelectorAll('.shopify-app-block'))
      .filter(isDonationWidget).length;
    var cardSlots = document.querySelectorAll(CONFIG.cardSlots).length;
    var hero = document.querySelector(CONFIG.heroSlot) ? 1 : 0;

    console.log('[GOW] donation-widget blocks found:', blocks,
                '| hero slot present:', !!hero,
                '| card slots found:', cardSlots);

    if (blocks < hero + cardSlots) {
      console.warn('[GOW] Fewer plugin app blocks than slots. ' +
                   'Add the plugin app block once per campaign (4 total) — ' +
                   'that is why some slots stay empty.');
    }
  }

  /* ---------- run + bounded retry (widgets load async) ---------- */
  function start() {
    var done = moveWidgets();
    diagnose();

    if (done) return;

    pollTimer = setInterval(function () {
      var ok = moveWidgets();
      if (ok || ++pollAttempts > CONFIG.pollMaxAttempts) {
        clearInterval(pollTimer);
        pollTimer = null;
        diagnose();
      }
    }, CONFIG.pollMs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.gow-tier-card__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var btn = form.querySelector('[data-gow-tier-submit]');
      if (!btn || btn.disabled) return;

      e.preventDefault();
      var textEl = btn.querySelector('.gow-tier-card__btn-text');
      var originalText = textEl ? textEl.textContent : '';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: 1
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          if (textEl) textEl.textContent = 'ADDED ✓';
          btn.classList.add('is-added');
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function () {
            btn.classList.remove('is-added');
            if (textEl) textEl.textContent = originalText;
            btn.disabled = false;
          }, 1800);
                    window.location.href = '/checkout';

        })
        .catch(function () {
          btn.disabled = false;
          form.submit();
        });
    });
  });
});